import { get, post, patch, del } from "./client";
import { ApiEndpoint } from "./endpoints";

export interface Meal {
	id: string;
	name: string;
	info?: string;
}

export const getMeals = async () => {
	const r = await get(ApiEndpoint.Meals);

	return r[0] as Meal[];
};

export const addMeal = async (meal: Meal) => {
	return await post(ApiEndpoint.Meals, meal) as Meal;
}

export const patchMeal = async (id: string, updateData: Partial<Meal>) => {
	return await patch(ApiEndpoint.Meals, id, updateData) as Meal;
}

export const removeMeal = async (id: string) => {
	return await del(ApiEndpoint.Meals, id);
}
